var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DrawerAccordion",
    {
      attrs: { id: "corp", title: _vm.$t.__("overview.companyBlock.title") },
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function() {
            return [
              _vm.showEditButton
                ? _c("CompassPlainButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.edit"),
                      size: "small"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.handleEdit($event)
                      }
                    }
                  })
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "overview-company-block" },
        [
          _c(
            "div",
            { staticClass: "overview-company-block__company" },
            [
              _c(
                "CompassTooltip",
                {
                  attrs: {
                    content: _vm.$t.__("common.actions.see_the_file"),
                    arrow: false,
                    placement: "right-start"
                  }
                },
                [
                  _c(
                    "RouterLink",
                    { attrs: { to: _vm.companyLink } },
                    [
                      _c("CompassObject", {
                        attrs: {
                          size: "extra-small",
                          label: _vm.company.name,
                          isLink: true
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "CompassDescriptionList",
            { attrs: { variant: "frozen-field" } },
            [
              _vm.company.email
                ? _c(
                    "CompassDescriptionListItem",
                    { attrs: { label: _vm.$t.__("common.labels.email") } },
                    [
                      _c(
                        "EmailLinkCompass",
                        {
                          attrs: {
                            email: _vm.company.email,
                            linkedid: _vm.linkedid,
                            linkedtype: _vm.linkedtype
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.company.email) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.company.phone
                ? _c(
                    "CompassDescriptionListItem",
                    { attrs: { label: _vm.$t.__("common.labels.phone") } },
                    [
                      _c("PhoneLinkCompass", {
                        attrs: { phoneNumber: _vm.company.phone }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              Object.keys(_vm.address).length
                ? _c(
                    "CompassDescriptionListItem",
                    { attrs: { label: _vm.$t.__("common.labels.address") } },
                    [
                      _vm.isLoading
                        ? _c("CompassSkeleton", {
                            attrs: { variant: "line", lines: 2 }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isLoading
                        ? _c("div", {
                            staticClass:
                              "typographies-paragraph-medium-regular overview-company-block__address",
                            domProps: {
                              innerHTML: _vm._s(_vm.formattedAddress)
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }